import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EFilterType, ICellConfig, ITableConfig, ITableGroupAction} from "../../../interface/table.config";
import {NgForOf, NgIf, TitleCasePipe} from "@angular/common";
import {ICrudRes} from "../../../interface/http.config";
import {MatIcon} from "@angular/material/icon";
import {BaseEditFilterComponent} from "../base-edit-filter/base-edit-filter.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-base-list',
  standalone: true,
  imports: [
    NgForOf,
    MatIcon,
    NgIf,
    TitleCasePipe
  ],
  templateUrl: './base-list.component.html',
  styleUrl: './base-list.component.scss'
})
export class BaseListComponent {


  @Input() tableConfig: ITableConfig;
  @Input() filters: Record<string, any>;
  @Input() filterLabels: Record<string, any>;
  @Input() sortBy: string;
  @Input() sortDirection: string;
  @Input() data: ICrudRes;
  @Input() groupActions: ITableGroupAction[] = [
    {
      action: 'new',
      name: 'create',
      icon: 'add',
    },
    {
      action: 'csv',
      name: 'csv',
      icon: 'description',
    },
  ];


  @Output() action = new EventEmitter<{name: string, data: any}>();

  constructor(protected dialog: MatDialog) {
  }

  sortIcon(field: string) {
    if (field !== this.sortBy) {
     return 'swap_vert';
    }

    return this.sortDirection === 'desc' ? 'arrow_upward' : 'arrow_downward';
  }

  openFilter(field: string): void {

    const config = this.tableConfig.cells.find(item => item.field === field);
    const curVal = this.filters[field] || null;

    const dialogRef = this.dialog.open(BaseEditFilterComponent, {
      data: {field, config, curVal},
    });

    dialogRef.afterClosed().subscribe((result: {value: any, field: string}) => {
      if (!result) return;

      this.act('change-field', {...result, config});
    });
  }

  prepareHeader(header: string | Function) {
    return typeof header === 'string' ? header : header();
  }

  pickPage(page: number) {
    this.action.next({name: 'pick-page', data: page});
  }

  prepareValue(item: any, cell: ICellConfig) {
    return cell.value ? cell.value(item) : item[cell.field];
  }

  act(actionName: string, row: any = null) {
    this.action.next({
      name: actionName,
      data: row,
    });
  }

  changeSort(field: string) {
    this.act('change-search', { field });
  }

  get maxPage() {
    return Math.ceil(this.data.total / this.data.perPage);
  }

  protected readonly Math = Math;
  protected readonly EFilterType = EFilterType;
}
